import IRequest from "../../IRequest"

export interface IDataDepartamentosFinanceiros {
    id: number,
    nome: string
}

export interface IPesquisarDepartamentosFinanceiros {
    reqDepartamentos: IRequest<IDataDepartamentosFinanceiros>,
    dataDepartamentos: IDataDepartamentosFinanceiros[]
}

export const defValueDepartamentoFinanceiro: IDataDepartamentosFinanceiros = {
    id: 0,
    nome: '',
}